import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import FeatureSection from './components/FeatureSection';
import StatsSection from './components/StatsSection';
import DownloadCTA from './components/DownloadCTA';
import ArticlePreview from './components/ArticlePreview';
import FAQSection from './components/FAQSection';
import { useEffect } from 'react';

export default function Home() {
  useEffect(() => {
    document.title = '91浏览器官方下载与使用指南 - 极速安全移动浏览器 | 91浏览器';
  }, []);

  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <FeatureSection />
        <StatsSection />
        <DownloadCTA />
        <ArticlePreview />
        <FAQSection />
      </main>
      <Footer />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            name: '91浏览器官方下载与使用指南',
            description:
              '91浏览器是一款功能强大的移动浏览器，提供极速上网、隐私保护、多标签浏览等核心功能。',
            isPartOf: {
              '@type': 'WebSite',
              name: '91浏览器',
              url: 'https://www.91browser.com',
            },
          }),
        }}
      />
    </>
  );
}